import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Send } from 'lucide-react';
export function ContactSection() {
  return <section id="contact" className="py-24 bg-white" data-id="element-67">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-68">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-69">
          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-70">
            <h2 className="text-4xl font-bold text-gray-900 mb-6" data-id="element-71">
              Contact Us
            </h2>
            <p className="text-lg text-gray-600 mb-8" data-id="element-72">
              Interested in our minerals or looking to establish a partnership?
              Contact us for quotes and inquiries.
            </p>

            <form className="space-y-6" data-id="element-73">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-74">
                <div data-id="element-75">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-76">
                    Name
                  </label>
                  <input type="text" id="name" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-drc-blue focus:border-transparent outline-none transition-all bg-gray-50 focus:bg-white" placeholder="John Doe" data-id="element-77" />
                </div>
                <div data-id="element-78">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-79">
                    Email
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-drc-blue focus:border-transparent outline-none transition-all bg-gray-50 focus:bg-white" placeholder="john@example.com" data-id="element-80" />
                </div>
              </div>

              <div data-id="element-81">
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-82">
                  Subject
                </label>
                <select id="subject" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-drc-blue focus:border-transparent outline-none transition-all bg-gray-50 focus:bg-white" data-id="element-83">
                  <option data-id="element-84">General Inquiry</option>
                  <option data-id="element-85">Gold Purchase</option>
                  <option data-id="element-86">Diamond Purchase</option>
                  <option data-id="element-87">Gemstone Purchase</option>
                  <option data-id="element-88">Partnership Opportunity</option>
                </select>
              </div>

              <div data-id="element-89">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-90">
                  Message
                </label>
                <textarea id="message" rows={4} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-drc-blue focus:border-transparent outline-none transition-all bg-gray-50 focus:bg-white" placeholder="Tell us about what you're looking for..." data-id="element-91"></textarea>
              </div>

              <button type="submit" className="w-full md:w-auto px-8 py-4 bg-drc-blue text-white font-medium rounded-lg hover:bg-drc-dark transition-colors duration-300 flex items-center justify-center shadow-lg hover:shadow-xl transform hover:-translate-y-0.5" data-id="element-92">
                Send Message
                <Send size={18} className="ml-2" data-id="element-93" />
              </button>
            </form>
          </motion.div>

          {/* Contact Info & Map */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex flex-col h-full" data-id="element-94">
            <div className="bg-gray-50 p-8 rounded-2xl mb-8" data-id="element-95">
              <h3 className="text-xl font-semibold text-gray-900 mb-6" data-id="element-96">
                Contact Information
              </h3>
              <div className="space-y-6" data-id="element-97">
                <div className="flex items-start" data-id="element-98">
                  <div className="bg-white p-3 rounded-full shadow-sm text-drc-blue mr-4" data-id="element-99">
                    <MapPin size={20} data-id="element-100" />
                  </div>
                  <div data-id="element-101">
                    <p className="font-medium text-gray-900" data-id="element-102">Address</p>
                    <p className="text-gray-600" data-id="element-103">
                      97, Av des Orchidées, Quartier les Volcans
                      <br data-id="element-104" />
                      Commune de Goma, Ville de Goma
                      <br data-id="element-105" />
                      Nord-Kivu, RD Congo B.P. 456
                    </p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-106">
                  <div className="bg-white p-3 rounded-full shadow-sm text-drc-blue mr-4" data-id="element-107">
                    <Phone size={20} data-id="element-108" />
                  </div>
                  <div data-id="element-109">
                    <p className="font-medium text-gray-900" data-id="element-110">Phone</p>
                    <p className="text-gray-600" data-id="element-111">+243994387818</p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-112">
                  <div className="bg-white p-3 rounded-full shadow-sm text-drc-blue mr-4" data-id="element-113">
                    <Mail size={20} data-id="element-114" />
                  </div>
                  <div data-id="element-115">
                    <p className="font-medium text-gray-900" data-id="element-116">Email</p>
                    <p className="text-gray-600" data-id="element-117">
                      kalecooperativeminerals@gmail.com
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Map Placeholder */}
            <div className="flex-1 bg-gray-200 rounded-2xl min-h-[300px] relative overflow-hidden" data-id="element-118">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.7565!2d29.2286!3d-1.6792!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMcKwNDAnNDUuMSJTIDI5wrAxMyczNy4xIkU!5e0!3m2!1sen!2s!4v1234567890" width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" className="rounded-2xl" data-id="element-119"></iframe>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}